import React from 'react';
import { TopNav } from '../components/TopNav';
import { Footer } from '../components/Footer';

export const HelpCenterPage: React.FC = () => (
  <div className="min-h-screen bg-white flex flex-col">
    <TopNav />
    <div className="flex-1 flex flex-col items-center justify-center p-8">
      <h1 className="text-3xl font-bold mb-4">Help Center</h1>
      <p className="text-lg text-gray-600">Support resources and FAQs are coming soon.</p>
    </div>
    <Footer />
  </div>
); 